
<template>
    <BFormGroup label="ОПИС">
        <QuillEditor
            v-model:content="tender.description"
            contentType="html"
            theme="snow"
            :toolbar="toolbar"
            placeholder="Введіть опис…"
            class="tender-editor"
        />
        
        <BButton class="mt-2" variant="outline-success" @click="showDescriptionTemplates">З шаблону</BButton>
    </BFormGroup>
    
    <descriptions_template @setTemplate="setTemplate"></descriptions_template>
</template>

<script>
import {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
} from 'bootstrap-vue-next';
import { QuillEditor } from '@vueup/vue-quill';
import descriptions_template from "./fields/descriptions_template.vue";

export default {
    name: "tender_description",
    props : {
        tender : {
            type : Object
        }
    },
    emits : ['changeAtr'],
    
    components : {
        BForm,
        BFormGroup,
        BFormInput,
        QuillEditor,
        BButton,
        descriptions_template
    },
    
    data() {
        return {
            toolbar: [
                ['bold', 'italic', 'underline', 'link'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                ['clean'] // по желанию (ластик)
            ]
        }
    },
    
    methods : {
        
        setTemplate(text) {
            this.tender.description = text;
        },
        
        showDescriptionTemplates() {
            EventBus.$emit('show_description');
        }
    }
    
    
}
</script>


<style scoped>

</style>